/**
 * Alerta de tickets de alumno sin respuesta en 24 horas (ticket 78169).
 * Esther (568) y Paola Zuyin (1312) la reciben sola cada hora.
 * Jefe de TI (11) y Desarrollador de software (12) solo la abren desde el botón.
 */
export const IDERPS_ALERTA_TICKETS_AUTOMATICA = [568, 1312]
export const PUESTOS_ALERTA_TICKETS_CONSULTA = [11, 12]

export function esAlertaTicketsAutomatica(usuario) {
  return !!usuario && IDERPS_ALERTA_TICKETS_AUTOMATICA.includes(Number(usuario.iderp))
}

export function puedeVerAlertaTickets(usuario) {
  if (!usuario) return false
  return esAlertaTicketsAutomatica(usuario) || PUESTOS_ALERTA_TICKETS_CONSULTA.includes(Number(usuario.idpuesto))
}
